import { Component } from '@angular/core';
import { TeranetSummaryModalComponent } from '../summary-docket/modal/modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { TestHooks } from './check-sync.hooks';

@Component({
	selector: 'app-check-sync',
	templateUrl: './check-sync.component.html',
	standalone: false,
})
export class CheckSyncComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	constructor(
		private dialog: MatDialog,
		private matDialog: MatDialogRef<CheckSyncComponent>,
	) {}

	skip = () => {
		this.matDialog.close();
	};

	showDocketSummary = () => {
		this.matDialog.close();
		this.dialog.open(TeranetSummaryModalComponent, {
			width: '70%',
			height: '70%',
		});
	};
}
